import { PhoneFormData } from "../../interfaces/phone-form-data.interface";
import { PhoneFormActionType as AT } from "./phone-form.action-type.enum";

export const phoneFormActions = {
  update: (fields: Partial<PhoneFormData>) => ({
    type: AT.UPDATE_FORM as typeof AT.UPDATE_FORM,
    payload: { fields },
  }),
};